import React from 'react';

/**
 * Lets a fixed React route inject its own content into the config-driven layout
 * chrome. `FixedConfigPage` provides it around `<PageLayout>`; `Page` consumes it
 * in the layout's `PageContent` slot and renders `content` instead of the page's
 * CraftJS tree — but ONLY when `pageId` matches the Page's id (so an auth/login
 * swap, which renders a different pageId in the slot, is never hijacked).
 */
export type FixedPageContent = {
  pageId?: string;
  content: React.ReactNode;
};

export const FixedPageContentContext = React.createContext<FixedPageContent | null>(null);
